// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29xYZ","rootNoMargin":"styles_rootNoMargin__2EcWi"};